import { render } from "./TopicListView.vue?vue&type=template&id=418d2b79"
import script from "./TopicListView.vue?vue&type=script&lang=js"
export * from "./TopicListView.vue?vue&type=script&lang=js"

import "./TopicListView.vue?vue&type=style&index=0&id=418d2b79&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__